import { type MessageDescriptor } from 'react-intl-next';

import { GoalsIcon, ProjectsIcon } from '@atlaskit/logo';

import { type RovoLogo, RovoLogoFromLogo } from './icons';
import { CustomLinkIcon } from './icons/custom-link-icon';
import { messages } from './messages';

export interface NounConfig {
	displayName: MessageDescriptor;
	displayNamePlural: MessageDescriptor;
	Icon: RovoLogo;
}

export const NounKeys = {
	project: 'project',
	goal: 'goal',
	// tag: 'tag',
	AtlassianWebCrawler: 'atlassian-web-crawler',
} as const;

export type NounKeys = (typeof NounKeys)[keyof typeof NounKeys];

export const isNounKey = (key: string): key is NounKeys => {
	return Object.values(NounKeys).includes(key as NounKeys);
};

export const nouns: Record<string, NounConfig> = {
	[NounKeys.project]: {
		displayName: messages.project,
		displayNamePlural: messages.projects,
		Icon: RovoLogoFromLogo(ProjectsIcon, 'Project'),
	},
	[NounKeys.goal]: {
		displayName: messages.goal,
		displayNamePlural: messages.goals,
		Icon: RovoLogoFromLogo(GoalsIcon, 'Goal'),
	},
	//Tag Noun has been omitted because it is not currently implemented in FPS and risks visual degradation with the t25 icon update
	//Discussion here: https://atlassian.slack.com/archives/C08HFJLM7J5/p1742856483784089
	// [NounKeys.tag]: {
	// 	displayName: messages.tag,
	// 	displayNamePlural: messages.tags,
	// 	Icon: RovoLogoFromLogo(HashtagIcon, 'Tag'),
	// },
	[NounKeys.AtlassianWebCrawler]: {
		displayName: messages.webPage,
		displayNamePlural: messages.webPages,
		Icon: RovoLogoFromLogo(CustomLinkIcon, 'Atlassian Web Crawler'),
	},
};

export const NOUNS_ORDER: NounKeys[] = [
	NounKeys.project,
	NounKeys.goal,
	// NounKeys.tag,
	NounKeys.AtlassianWebCrawler, // Web Crawler is not a noun, we should improve this
];
